import React, {Suspense, Component} from "react";
import { Routes, Route } from "react-router-dom";

import Login from "../auth/Login";

import Home from "../home/Home";

import LocalEvents from "../event/LocalEvents";
import EventDetails from "../event/EventDetails";

import Organizations from "../organization/Organizations";
import OrganizationDetails from "../organization/OrganizationDetails";

class Routing extends Component {
    render() {
        return (
            <>
                <Suspense fallback={"Loading..."}>
                    <Routes>

                        {/*Login*/}
                        <Route exact path="/login" element={<Login/>}/>

                        {/*home*/}
                        <Route path="/" element={<Home/>}/>

                        {/*local events*/}
                        <Route exact path="/events" element={<LocalEvents/>}/>
                        <Route path='/event/:event_id' element={<EventDetails/>}/>

                        {/*Organizations*/}
                        <Route exact path="/organizations" element={<Organizations/>}/>
                        <Route path='/organization/:organization_id' element={<OrganizationDetails/>}/>

                    </Routes>
                </Suspense>
            </>
        );
    }
}

export default Routing;